import {
    DEALERCASHLIFTINGLIST_SUCCESS,
    DEALERCASHLIFTINGLIST_FAILED,
    RESET_DEALERCASHLIFTINGLIST,
    LOADING_DEALERCASHLIFTINGLIST,
    NETWORK_ERROR_DEALERCASHLIFTINGLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERCASHLIFTINGLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERCASHLIFTINGLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERCASHLIFTINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERCASHLIFTINGLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERCASHLIFTINGLIST:
            return (state = initialState);
        default:
            return state;
    }
};
